
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-listing",
      function () {
        return require("private-next-pages/product-listing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-listing"])
      });
    }
  